import { theme } from '@theme';
import styled from 'styled-components';

export const SearchForm = styled.div<{ isMobileDevice: boolean; isTabletDevice: boolean }>`
  height: 30px;
  position: relative;

  input[type='text'] {
    padding: 0 19px 0 25px;

    box-sizing: border-box;
    border-top: 1px solid ${theme.palette.purpleThree};
    border-left: 1px solid ${theme.palette.purpleThree};
    border-bottom: 1px solid ${theme.palette.lightPurpleThree};
    border-right: 1px solid ${theme.palette.lightPurpleThree};

    letter-spacing: 0.05em;
    outline: none;
    border-radius: 5px;
    transition: all 0.1s ease-in-out;
    &:focus {
      font-weight: ${theme.typography.fontWeights.medium};
    }
  }

  .am-icon-x {
    color: ${theme.palette.palePurple};
    cursor: pointer;
  }

  input[type='image'] {
    position: relative;
    top: 4px;
  }

  .hidden {
    display: none;
  }

  ${(props) =>
    !props.isMobileDevice
      ? `
      margin: 15px 20px;

      .am-icon-x {
        position: absolute;
        right: 4px;
        top: 5px;
      }
      input[type='text']::-webkit-input-placeholder {
        /* Chrome/Opera/Safari */
        color: ${theme.palette.palePurple};
      }
      input[type='text']::-moz-placeholder {
        /* Firefox 19+ */
        color: ${theme.palette.palePurple};
      }
      input[type='text']:-ms-input-placeholder {
        /* IE 10+ */
        color: ${theme.palette.palePurple};
      }
      input[type='text']:-moz-placeholder {
        /* Firefox 18- */
        color: ${theme.palette.palePurple};
      }
      input[type='text'] {
        width: 100%;
        font-size: ${theme.typography.fontSize}px;
        font-weight: ${theme.typography.fontWeights.thin};
        height: 30px;
        color: ${theme.palette.palePurple};
        background: ${theme.palette.purpleFour};
        &:focus {
          color: ${theme.palette.text.purple};
          background-color: ${theme.palette.lightPurpleFour};
            + .am-icon-loupe,
            ~ .am-icon-x {
              color: ${theme.palette.text.purple};
            }
          }
      }

      .am-icon-loupe {
        font-size: 130%;
        position: absolute;
        top: 6px;
        left: 4px;
        color: ${theme.palette.palePurple};
      }
      `
      : `
      margin: 15px 12px;
      padding: 2px;

      .am-icon-loupe {
        color: ${theme.palette.white};
        font-size: 24px;
        &:focus {
          color: ${theme.palette.text.purple};
        }
      }

      .am-icon-x {
        color: ${theme.palette.white};
        cursor: pointer;
        line-height: inherit;
      }

      input[type='text'] {
        padding-left: 13px;
      }
      `}
`;

export const SearchDealsInnerWrapper = styled.div<{ isMobileDevice: boolean }>`
  ${(props) =>
    props.isMobileDevice
      ? `
        position: absolute;
        z-index: 90;
        top: 45px;
        width: 100vw;
        right: -66px;
        `
      : ''}
`;
export const SearchDealsDiv = styled.div`
  width: 100%;
`;
export const SearchDealsInput = styled.div<{ isMobileDevice: boolean }>`
  .search-mobile-input {
    height: 40px;
    font-size: ${theme.typography.fontSize16}px;
    font-weight: ${theme.typography.fontWeights.normal};

    @media (orientation: portrait) {
      width: 84%;
    }

    @media (orientation: landscape) {
      width: 92%;
    }
  }

  ${(props) =>
    props.isMobileDevice
      ? `
        background-color: ${theme.palette.text.purple};
        text-align: center;
        flex-direction: row;
        display: flex;
        justify-content: space-evenly;
        padding: 8px 0px;
        line-height: 35px;
        `
      : ''}
`;
